module.exports = __webpack_public_path__ + "static/shopify-upsell-118f3dedde9a1b0802e399f143ea633e.mp4";